import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlCreationOptions, UrlTree} from '@angular/router';
import {map, take} from 'rxjs/operators';
import {encodeReturnUrl} from '@webmate-web-core/shared/utils/route-access';
import {AuthService} from '@webmate-web-core/shared/services/auth.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return authService.observeAuthStatus().pipe(take(1), map((authStatus) => {
        if (!authStatus) {
            // Trying to access an auth protected route without being authorized.
            let qp = {queryParams: {...route.queryParams}};
            if (!qp.queryParams['returnUrl'] && !!state.url && state.url !== '/projects') {
                // exclude the /projects route as it's the default anyway
                // get the url and set it as returnUrl
                qp.queryParams['returnUrl'] = encodeReturnUrl(state.url);
            }
            return router.createUrlTree(authService.getLoginUrlPath(), qp);
        }
        return authStatus;
    }));
}
